import React from 'react';
import { ResponsivePie } from '@nivo/pie';

const MAX_OPTIONS = 8;
const COLORS = [
    '#1f77b4', '#ff7f0e', '#2ca02c',
    '#d62728', '#9467bd', '#8c564b',
    '#e377c2', '#7f7f7f'
];
const HIGHLIGHT_COLOR = '#00c49f';

const PoolDoublePieChart = ({ poolItems }) => {
    if (!poolItems || poolItems.length === 0) {
        return <p className="text-muted small fst-italic">No data available yet.</p>;
    }

    const stats = Array.from({ length: MAX_OPTIONS }, (_, i) => ({
        option: i + 1,
        totalRating: 0,
        count: 0,
        wins: 0,
    }));

    poolItems.forEach((item) => {
        for (let i = 1; i <= MAX_OPTIONS; i++) {
            const rating = item[`pool_item${i}_rating`];
            if (rating != null) {
                stats[i - 1].totalRating += rating;
                stats[i - 1].count += 1;
            }
        }
        const winner = parseInt(item.winner);
        if (winner >= 1 && winner <= MAX_OPTIONS) {
            stats[winner - 1].wins += 1;
        }
    });

    const maxWins = Math.max(...stats.map(stat => stat.wins));

    const pieData = stats
        .filter(stat => stat.count > 0)
        .map((stat, index) => {
            const avgRating = (stat.totalRating / stat.count).toFixed(2);
            return {
                id: `Option ${stat.option}`,
                label: `Option ${stat.option}`,
                value: parseFloat(avgRating),
                wins: stat.wins,
                avgRating,
                color: stat.wins === maxWins && maxWins > 0 ? HIGHLIGHT_COLOR : COLORS[index]
            };
        });

    const pieDataWins = pieData.map((d, index) => ({
        ...d,
        value: d.wins || 0
    }));

    return (
        <>
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-start gap-1 flex-wrap">
                {/* Первый график: Average Ratings */}
                <div className="flex-grow-1" style={{ height: 250, maxWidth: 350, minWidth: 290 }}>
                    <h6 className="text-center text-muted">Average Ratings</h6>
                    <ResponsivePie
                        data={pieData}
                        valueFormat={v => `${v.toFixed(2)}★`}
                        colors={({ data }) => data.color}
                        margin={{ top: 40, right: 20, bottom: 40, left: 20 }}
                        innerRadius={0.5}
                        padAngle={2}
                        cornerRadius={4}
                        activeOuterRadiusOffset={8}
                        borderWidth={1}
                        borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
                        arcLabelsSkipAngle={10}
                        arcLabelsTextColor="#fff"
                    />
                </div>

                {/* Второй график: Wins */}
                <div className="flex-grow-1" style={{ height: 250, maxWidth: 350, minWidth: 290 }}>
                    <h6 className="text-center text-muted">Total Wins</h6>
                    <ResponsivePie
                        data={pieDataWins}
                        valueFormat={v => `${v} wins`}
                        colors={({ data }) => data.color}
                        margin={{ top: 40, right: 20, bottom: 40, left: 20 }}
                        innerRadius={0.5}
                        padAngle={2}
                        cornerRadius={4}
                        activeOuterRadiusOffset={8}
                        borderWidth={1}
                        borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
                        arcLabelsSkipAngle={10}
                        arcLabelsTextColor="#fff"
                    />
                </div>

                {/* Легенда */}
                <div className="flex-grow-1 ps-md-3" style={{ minWidth: 150 }}>
                    <h6 className="text-muted mb-2">Legend:</h6>
                    <ul className="small ps-0 text-muted">
                        {pieData.map((d) => (
                            <li key={d.id} style={{ marginBottom: 3, listStyle: 'none' }}>
                    <span style={{
                        display: 'inline-block',
                        width: 12,
                        height: 12,
                        backgroundColor: d.color,
                        borderRadius: '50%',
                        marginRight: 8
                    }}></span>
                                {d.label} – {d.avgRating}★ / {d.wins} wins
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            {/* Описание расчётов */}
            <div className="mt-4 mb-0 small text-muted text-start">
                <p><strong>How values are calculated:</strong></p>
                <ul>
                    <li><strong>Average Rating:</strong> Sum of all ratings per option divided by total responses. Rounded to 2 decimal places.</li>
                    <li><strong>Total Wins:</strong> Number of times the option was marked as winner.</li>
                    <li><strong>Highlight:</strong> The option with the most wins is colored differently.</li>
                </ul>
            </div>

        </>

    );
};

export default PoolDoublePieChart;
